import { MouseEventHandler } from "react";
import { ClusterNodeNote } from "../../models/Cluster"
import { Card, Row } from "react-bootstrap";
import { Flex, Tooltip } from "antd";
import { formatDate } from "../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./NoteItem.scss";

type Props = {
  note: ClusterNodeNote;
  onClick?: MouseEventHandler<HTMLDivElement>;
  onEdit?: MouseEventHandler<HTMLButtonElement>;
  onDelete?: MouseEventHandler<HTMLButtonElement>;
}

export default function NoteItem({ note, onClick, onEdit, onDelete }: Props) {

  return (
    <Card className="app-list-item note-item" onClick={onClick}>
      <Card.Header className="list-item-header bg-note py-1">
        <Flex className="gx-0 mb-1 align-items-start text-muted application-date text-dark">
          <b>Created</b>&nbsp;
          <span>{formatDate(note.createDateTime!)}</span>
        </Flex>
        <div className="header-content p-0">
          <Tooltip title={note.name} mouseEnterDelay={0.3}>
            <h5 className="list-item-title text-start">{note.name}</h5>
          </Tooltip>
          <p className="note-description text-dark text-start line-clamp-3">{note.description}</p>
        </div>

        <Row className="gx-0 justify-content-center hoverable-actions">
          <Tooltip title="Edit Note" mouseEnterDelay={0.3}>
            <button className="circle-button dark ms-2" onClick={onEdit}>
              <FontAwesomeIcon size="sm" icon={solid('pen')} />
            </button>
          </Tooltip>
          <Tooltip title="Delete Note" mouseEnterDelay={0.3}>
            <button className="circle-button dark ms-2" onClick={onDelete}>
              <FontAwesomeIcon size="sm" icon={solid('trash')} />
            </button>
          </Tooltip>
        </Row>
      </Card.Header>
    </Card>
  )
}